<template>
  <el-drawer
    :title="title"
    :visible.sync="showDrawer"
    :with-header="true"
    :size="drawerWidth"
    :wrapperClosable="false"
    :before-close="handleClose"
  >
    <div class="px-6">
      <div class="flex flex-col w-full justify-center items-center mb-8">
        <div class="ml-3 flex w-full justify-center items-center">
          <frozen-credit-card v-if="cardIsFrozen" />
          <credit-card-2 v-else />
        </div>
        <div class="flex justify-center items-end">
          <div
            v-for="(action, index) in cardActions"
            :key="index"
            class="px-6 flex flex-col items-center"
          >
            <button
              class="w-14 h-14 mb-2 border rounded-lg flex justify-center items-center"
              :class="{ 'bg-primary': action.hidden }"
            >
              <component :is="action.icon" />
            </button>
            <p
              class="text-fg-muted text-11px font-normal text-center whitespace-nowrap"
            >
              {{ action.name }}
            </p>
          </div>
        </div>
      </div>
      <div class="border rounded-lg py-5 pl-6 pr-8">
        <p class="mb-7">Card Details</p>
        <div class="flex mb-4" v-for="(data, index) in cardData" :key="index">
          <div>
            <p class="text-11px text-fg-muted font-normal">{{ data.title }}</p>
            <h4>{{ data.value }}</h4>
          </div>
          <button
            class="ml-auto"
            v-clipboard:copy="data.value"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon-3 />
          </button>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'

export default {
  props: {
    showDrawer: {
      type: Boolean,
      required: true
    },
    cardIsFrozen: {
      type: Boolean,
      required: false,
      default: () => false
    },
    cardData: {
      type: Array,
      required: true
    }
  },
  components: {
    DownloadIcon: () => import('@/assets/v2/icons/DownloadIcon3.vue'),
    FreezeIcon: () => import('@/assets/v2/icons/FreezeIcon2.vue'),
    UnfreezeIcon: () => import('@/assets/v2/icons/UnfreezeIcon.vue'),
    EditIcon: () => import('@/assets/v2/icons/EditIcon.vue'),
    DisabledIcon: () => import('@/assets/v2/icons/DisabledIcon.vue'),
    CopyIcon3: () => import('@/assets/v2/icons/CopyIcon3.vue'),
    FrozenCreditCard: () => import('@/assets/v2/icons/FrozenCreditCard.vue'),
    CreditCard2: () => import('@/assets/v2/icons/CreditCard2.vue')
  },
  computed: {
    title () {
      return 'Victor Spending'
    },
    drawerWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '100%'
    },
    cardActions () {
      return [
        { name: 'Rename', icon: 'edit-icon', hidden: false },
        { name: 'Statement', icon: 'download-icon', hidden: false },
        {
          name: `${this.cardIsFrozen ? 'Unfreeze Card' : 'Freeze Card'}`,
          icon: `${this.cardIsFrozen ? 'unfreeze-icon' : 'freeze-icon'}`,
          hidden: this.cardIsFrozen
        },
        { name: 'Cancel Card', icon: 'disabled-icon', hidden: false }
      ]
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDrawer')
    },
    onCopy (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    filterCardActions () {
      // filter out action that are unavailable when a card is frozen
      if (this.cardIsFrozen) {
        this.cardActions = this.cardActions.filter(
          (action) => action.name !== 'Rename'
        )
      }
    }
  },
  mounted () {
    this.filterCardActions()
  }
}
</script>
<style scoped>
>>> .el-drawer__header {
  color: var(--foreground-default);
  font-size: 0.9rem;
  padding-bottom: 1rem;
  padding-top: 2rem;
  padding-left: 1.3rem;
  font-weight: 700;
  border-bottom: 1px solid var(--border-main);
}
>>> .el-drawer {
  background: var(--background-surface) !important;
}
</style>
